import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { DiagnosticsStatstResponse, DiagnosticsTotalCurrentIssueResponse } from '@app-assets/models/assets.model';
import { AssetsService } from '@app-assets/services/assets.service';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-diagnostics-stats',
  templateUrl: './diagnostics-stats.component.html',
  styleUrls: ['./diagnostics-stats.component.scss'],
})
export class DiagnosticsStatsComponent implements OnChanges {
  @Input() loader: boolean = false;
  @Input() public currentFleetSelected: string = '';
  public totalDevices: number = 0;
  public totalCurrentIssues: number = 0;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private assetsService: AssetsService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.currentFleetSelected && changes.currentFleetSelected.currentValue) {
      this.getTotalDeviceCount();
      this.getTotalCurrentIssue();
    }
  }

  public getTotalDeviceCount(isRefresh?: boolean) {
    this.loader = true;
    this.assetsService
      .getTotalDeviceCount(isRefresh)
      .pipe(
        takeUntil(this.ngUnsubscribe),
        finalize(() => {
          this.loader = false;
        })
      )
      .subscribe(
        (res: DiagnosticsStatstResponse) => {
          this.totalDevices = res.deviceCount;
        },
        () => {
          this.totalDevices = 0;
        }
      );
  }

  public getTotalCurrentIssue(isRefresh?: boolean) {
    const params = {
      startDate: this.assetsService.getStartDate(),
    };
    this.loader = true;
    this.assetsService
      .getTotalCurrentIssueCount(isRefresh, params)
      .pipe(
        takeUntil(this.ngUnsubscribe),
        finalize(() => {
          this.loader = false;
        })
      )
      .subscribe(
        (res: DiagnosticsTotalCurrentIssueResponse) => {
          this.totalCurrentIssues = res.totalDeviceCount;
        },
        () => {
          this.totalCurrentIssues = 0;
        }
      );
  }
}
